import { call } from 'redux-saga/effects';
import { APIHandler } from '../commonHandlers';

function* getTenants(api, action) {
  yield call(APIHandler, api, action);
}

export default {
  getTenants,
};
